/* eslint-disable no-shadow */
import APIV5 from '~/models/api';
// TODO remove dayjs
import dayjs from 'dayjs';
import Fuse from 'fuse.js';
import { nanoid } from 'nanoid';
import * as d3 from 'd3';
import Utils from '~/scripts/services/utils';
import KDate from '~/models/kdate';

/** @type {import('angular').IController} */
export default class {
	/* @ngInject */
	/**
	 * @param {import('angular').IScope} $scope
	 * @param {import('angular').IFilterService} $filter
	 * @param {any} User
	 * @param {import('angular').ICompileService} $compile
	 * @param {import('angular').ILocationService} $location
	 * @param {any} $anchorScroll
	 */
	constructor($scope, $filter, User, $compile, $location, $anchorScroll) {
		this.ngModelCtrl = undefined;

		/** @type {import('@knitiv/api-client-javascript').LifePeriod} */
		this.lifeperiod = {};
		this.refs = undefined;

		/** @type {any[]} */
		this.events = [];

		/** @type {any[]} */
		this.eventGroups = [];

		this.User = User;
		this.$filter = $filter;
		this.$scope = $scope;
		this.$compile = $compile;
		this.$location = $location;
		this.$anchorScroll = $anchorScroll;

		this.display = false;
		this.isAdmin = User.getProfil().admin === true;
		this.isFiltersCollaped = true;

		// Filters
		/** @type {?string} */
		this.dateStart = null;

		/** @type {boolean} */
		this.dateStartIsOpen = false;

		/** @type {?string} */
		this.dateEnd = null;

		/** @type {boolean} */
		this.dateEndIsOpen = false;

		/** @type {boolean} */
		this.showEditions = true;

		/** @type {boolean} */
		this.showAdditions = true;

		/** @type {boolean} */
		this.showDeletetions = true;

		/** @type {string} */
		this.search = '';

		/** @type {any[]} */
		this.users = [];

		this.breakpoints = {
			step1: ((/** @type {any} */ { width }) => width < 1350),
			step2: ((/** @type {any} */ { width }) => width < 760),
			step3: ((/** @type {any} */ { width }) => width < 580),
		};

		this.modes = {
			MOD: 'Mise à jour',
			ADD: 'Création',
			DEL: 'Suppression',
		};
	}

	/**
	 * @param {number} kright
	 */
	// eslint-disable-next-line class-methods-use-this
	krightToJson(kright) {
		const returnValue = [];
		if (kright) {
			// read
			if ((kright & 8) > 0) {
				returnValue.push('Lecture');
			}
			// create
			if ((kright & 4) > 0) {
				returnValue.push('Création');
			}
			// update
			if ((kright & 2) > 0) {
				returnValue.push('Modification');
			}
			// delete
			if ((kright & 1) > 0) {
				returnValue.push('Suppression');
			}
		}
		return returnValue;
	}

	/**
	 * @param {any} previous
	 * @param {any} current
	 */
	shouldShowTitle(previous, current) {
		if (!previous) {
			return true;
		}
		const previousTitle = previous.title;
		const currentTitle = current.title;

		return previousTitle !== currentTitle;
	}

	/**
	 * @param {any} element
	 */
	// eslint-disable-next-line class-methods-use-this
	timelineStructure(element) {
		/** @type {any} */
		const elt = {
			title: element.sdate.includes('INFINITY')
				? element.sdate
				: KDate.now().local().from(KDate.fromNumber(element.kdate)),
			date: element.kdate.toString(),
			sdate: element.sdate,
			dateDisplay: element.sdate.includes('INFINITY')
				? ''
				: KDate.fromNumber(element.kdate).local().format('DD/MM/YYYY HH:mm'),
			lines: [],
		};

		const eventLines = Object.values(element.list);

		elt.lines = eventLines;
		// console.log('eventLines', eventLines);
		elt.author = {
			name: this.getRef(eventLines[0].ref).profil_name,
			kid: this.getRef(eventLines[0].ref).profil_kid,
		};

		return elt;
	}

	// eslint-disable-next-line class-methods-use-this
	/**
	 * @param {{ display: boolean; }} event
	 */
	displayDetails(event) {
		event.display = event.display !== true;
	}

	/**
	 * @param {string} filename
	 * @returns {import('@knitiv/api-client-javascript').JsonToExcelInput}
	 */
	xlsKformat(filename) {
		/** @type {any} */
		const header = {
			A: {
				n: 'DATE',
				type: 's',
			},
			B: {
				n: 'STRUCTURE',
				type: 's',
			},
			C: {
				n: 'MODE',
				type: 's',
			},
			D: {
				n: 'PROFIL',
				type: 's',
			},
			E: {
				n: 'DATA',
				type: 's',
			},
			F: {
				n: 'DATA_COMPLEMENTS',
				type: 's',
			},
			G: {
				n: 'VALEURS',
				type: 's',
			},
			H: {
				n: 'VALEURS_COMPLEMENTS',
				type: 's',
			},
		};

		const rows = [];
		for (const event of this.events.filter(event => event.matched)) {
			/** @type {any} */
			const reference = this.refs[event.ref];

			/** @type {any} */
			const row = {
				A: {
					v: reference.sdated,
				},
				B: {
					v: event.structure,
				},
				C: {
					v: event.ope,
				},
				D: {
					v: reference.profil_name,
				},
			};

			/** @type {any} */
			const data = {};

			/** @type {any} */
			const values = {};

			/** @type {any} */
			const valuesComplements = {};

			/** @type {any} */
			const dataComplements = {};

			// eslint-disable-next-line unicorn/prefer-switch
			if (event.structure === 'KLINK') {
				data.v = `${reference.class_name
					+ (reference.linker_name ? (`::${reference.linker_name}`) : '')
				}`;
				values.v = `${reference.objnum2_name}`;
				valuesComplements.v = reference.objnum2_isa_name;
				dataComplements.v = reference.relation_kid;
			}
			else if (event.structure === 'KDROIT') {
				data.v = event.role_name;
				values.v = this.krightToJson(reference.kright).join(' - ');
			}
			else if (event.structure === 'KATTR') {
				data.v = reference.name;
				values.v = reference.value;
			}
			else if (event.structure === 'KNODE') {
				data.v = 'Fichier';
				values.v = event.file;
			}
			else if (event.structure === 'KREPRE') {
				data.v = reference.lang_name;
				values.v = reference.value_string;
			}

			row.E = data;
			row.F = dataComplements;
			row.G = values;
			row.H = valuesComplements;

			// DATE, STRUCTURE, MODE, PROFIL, DATA, VALEURS

			rows.push(row);
		}

		return {
			filename,
			header,
			rows,
		};
	}

	filterEvents() {
		// this.filteredEvents = [...this.events];
		for (const event of this.events) {
			event.matched = true;
		}
		for (const group of this.eventGroups) {
			group.matched = true;
		}

		// - Checkboxes -----------------------------------------------------------

		for (const event of this.events.filter(event => event.matched)) {
			/** @type {any} */
			const modes = {
				MOD: this.showEditions,
				ADD: this.showAdditions,
				DEL: this.showDeletetions,
				default: true,
			};
			event.matched = modes[event.ope] ?? modes.default;
		}

		// - Users ----------------------------------------------------------------

		if (this.users.length > 0) {
			for (const event of this.events
				.filter(event => event.matched)) {
				event.matched = this.users.map(user => user.kid).includes(this.refs[event.ref].profil_kid);
			}
		}

		// - Dates ----------------------------------------------------------------

		if (this.dateStart && this.dateEnd) {
			for (const event of this.events
				.filter(event => event.matched)) {
				const reference = this.refs[event.ref];

				const start = dayjs(this.dateStart);
				const end = dayjs(this.dateEnd);
				const search = dayjs.utc(reference.sdated).local();

				event.matched = search.isBetween(start, end);
			}
		}

		// - Search ---------------------------------------------------------------
		const options = {
			keys: [
				'isa',
				'isa_name',
				'kid',
				'kid_name',
				'ref',
				'ref_type',
				'type_kid',
				'class_kid',
				'class_name',
				'objnum2',
				'objnum2_isa',
				'objnum2_isa_name',
				'objnum2_name',
				'profil_kid',
				'profil_name',
				'relation_kid',
				'name',
				'value',
			],
			threshold: 0.4,
		};

		// Search only on already matched elements
		const fuse = new Fuse(
			this.events
				.filter(event => event.matched)
				.map(event => ({
					uid: event.uid,
					...this.refs[event.ref],
				})),
			options,
		);

		// eslint-disable-next-line unicorn/prefer-set-has
		const matches = fuse.search(this.search).map(search => search.item.uid);

		for (const event of this.events) {
			if (event.matched) {
				event.matched = this.search === '' ? event.matched : matches.includes(event.uid);
			}
		}

		// Filter event groups with 0 events
		for (const group of this.eventGroups) {
			group.matched = this.events.filter(event => event.matched && event.parentUid === group.uid).length;
		}
	}

	/**
	 * Toggle the state of all panels
	 *
	 * @param {boolean} toggle The new state
	 */
	toggleAll(toggle) {
		for (const group of this.eventGroups) {
			group.isOpen = toggle;
		}
	}

	getMatchedEditionsAmount() {
		return this.eventGroups.filter(group => group.matched).length;
	}

	getMatchedEventsAmount() {
		return this.events.filter(event => event.matched).length;
	}

	dlxlsx() {
		const date = new Date();
		const datajson = this.xlsKformat(`histo_${this.kid}_${this.$filter('date')(date, 'yyyyMMdd')}`);
		APIV5.instance.jsonToExcel(datajson, { id: 'kform-tab-history.dlxlsx' })
			.then(response => {
				let filename = null;
				const	r = /filename="(.+)"/.exec(response.headers('content-disposition'));
				if (r) {
					filename = r[1];
				}
				Utils.download(response.buffer, response.headers('content-type'), filename);
				return true;
			})
			.catch(error => {
				console.error('Unable to generate Excel file!', error);
			});
	}

	drawChart() {
		// https://bl.ocks.org/tristanwietsma/f4997974b5602a5b48ec8eba104335d4
		// https://bl.ocks.org/robyngit/e95219af7bad2c91b8d8bb8e95251ca2

		const startOfMonth = dayjs().startOf('month');
		const endOfMonth = dayjs().endOf('month');

		const events = [];
		for (const group of this.eventGroups) {
			const innerEvents = this.events.filter(event => event.parentUid === group.uid);

			events.push({
				date: group.date,
				amount: innerEvents.length,
			});
		}

		events.shift();
		events.shift();

		const margin = {
			top: 20, right: 20, bottom: 200, left: 50,
		};
		const margin2 = {
			top: 20, right: 20, bottom: 50, left: 50,
		};
		const width = 1920 - margin.left - margin.right;
		const height = 1080 - margin.top - margin.bottom;
		const width2 = 1920 - margin2.left - margin2.right;
		const height2 = 200 - margin2.top - margin2.bottom;

		// add svg with margin !important
		// this is svg is actually group
		const svg = d3.select('.chart')
			// .attr('width', width + margin.left + margin.right)
			// .attr('height', height + margin.top + margin.bottom);
			.attr('preserveAspectRatio', 'xMinYMin meet')
			.attr('viewBox', `0 0 ${1920} ${1080}`);

		const focus = svg.append('g') // add group to leave margin for axis
			.attr('transform', `translate(${margin.left},${margin.top})`);
		const context = svg.append('g')
			.attr('transform', `translate(${margin2.left},${height - height2 + 200})`);

		const maxHeight = d3.max(events, d => d.amount);
		// const minHeight = d3.min(events, d => d.amount);
		if (maxHeight === undefined) {
			return;
		}
		// set y scale
		const yScale = d3.scaleLinear().range([0, height]).domain([maxHeight, 0]);
		// add x axis
		const xScale = d3
			.scaleLinear()
			.range([0, width])
			// @ts-ignore
			.domain(d3.extent(events, d => d.date));

		// set y scale
		const yScale2 = d3.scaleLinear().range([0, height2]).domain([maxHeight, 0]);
		// add x axis
		const xScale2 = d3.scaleLinear()
			.range([0, width2])
			// @ts-ignore
			.domain(d3.extent(events, d => d.date));
		// add x and y axis
		// const yAxis = d3.axisLeft(yScale).tickSize(-width);
		// const yAxisGroup = focus.append('g').call(yAxis).style('font-size', '2em');
		const xAxis = d3.axisBottom(xScale);
		const xAxisGroup = focus.append('g').call(xAxis).attr('transform', `translate(0,${height})`).selectAll('text')
			.attr('transform', 'translate(-10,10)rotate(-35)')
			.style('text-anchor', 'end')
			.style('font-size', '2em')
			.style('fill', '#69a3b2');

		// const xAxis2 = d3.axisBottom(xScale2);
		// const xAxisGroup2 = context.append('g').call(xAxis2).attr('transform', `translate(0,${height2})`);

		const bars1 = focus.selectAll('rect').data(events).enter().append('rect');
		bars1
			.attr('class', 'bar')
			.attr('x', d => xScale(d.date))
			.attr('y', d => yScale(d.amount))
			.attr('width', 4)
			.attr('height', d => height - yScale(d.amount));
		bars1.attr('fill', () => 'steelblue');

		const bars2 = context.selectAll('rect')
			.data(events)
			.enter()
			.append('rect');

		bars2.attr('x', d => xScale2(d.date))
			.attr('y', d => yScale2(d.amount))// for bottom to top
			.attr('width', 4)
			.attr('height', d => height2 - yScale2(d.amount))
			.attr('class', 'bar2');
		bars2.attr('fill', () => 'steelblue');

		// add zoom
		/* var zoom = d3.zoom()
					.scaleExtent([1,Infinity])// &lt;1 means can resize smaller than  original size
					.translateExtent([[0,0],[width,height]])
					.extent([[0,0],[width,height]])//view point size
			svg.append("rect")
					.attr("class", "zoom")
					.attr("width", width)
					.attr("height", height)
					.attr("transform", "translate(" + margin.left + "," + margin.top + ")"); */
		// add brush
		// Brush must be added in a group

		// const zoom = d3.zoom()
		// 	.scaleExtent([0.9, 20])
		// 	.translateExtent([[0, 0], [width, height]])
		// 	.on('zoom', zoomUpdateChart);

		/**
		 * @param {{
		 *   selection: any,
		 *   sourceEvent: any,
		 * }} root0
		 */
		function brushed({
			selection, sourceEvent,
		}) {
			if (!sourceEvent) {
				return;
			} // Only transition after input.
			if (!selection) {
				return;
			} // Ignore empty selections.
			if (sourceEvent && sourceEvent.type === 'zoom') {
				return;
			}

			const scale = xScale.copy().domain(selection.map(xScale.invert));
			// @ts-ignore
			xAxisGroup.transition().duration(1000).call(d3.axisBottom(scale));

			focus.selectAll('.bar').attr('x', d => scale(d.date));
			context.selectAll('.bar2').attr('width', xScale.domain()[1] / xScale.domain()[0]);
		}

		/**
		 * @type {number[]}
		 */
		const initialBrushPosition = [
			Number.parseInt(KDate.fromDate(startOfMonth.toDate()).asString(), 10),
			Number.parseInt(KDate.fromDate(endOfMonth.toDate()).asString(), 10),
		];

		const brush = d3.brushX()
			.extent([[0, 0], [width2, height2]])
			.on('brush', brushed)
			.on('end', brushed);

		context.append('g')
			.attr('class', 'brush')
			.call(brush)
			// @ts-ignore
			.call(brush.move, initialBrushPosition.map(xScale));
		// .call(zoom.transform, d3.zoomIdentity.scale(width / selectionWidth).translate(-selection[0], 0));
	}

	/**
	 * @param {{ uid: any; }} group
	 * @returns {string}
	 */
	makeEventGroupTitle(group) {
		const events = this.events.filter(event => event.parentUid === group.uid && event.matched);
		const changes = events.length;

		// console.log('events', events);

		const creation = events.filter(event => event.ope === 'ADD' && event.structure === 'KNODE');
		if (creation.length > 0) {
			return 'Création du nœud';
		}

		const suppression = events.filter(event => event.ope === 'DEL' && event.structure === 'KNODE');
		if (suppression.length > 0) {
			return 'Suppression du nœud';
		}

		return `${changes} changement${changes > 1 ? 's' : ''}`;
	}

	async init() {
		const { lifeperiod, refs } = this.data;

		this.lifeperiod = lifeperiod;
		this.refs = refs;

		const periods = Object.values(this.lifeperiod);

		this.eventGroups = periods
			.map(period => this.timelineStructure(period))
			.sort((a, b) => b.date - a.date);
		// Assign a unique identifier to the group
		for (const group of this.eventGroups) {
			group.uid = nanoid();
			group.matched = true;
			group.isOpen = false;
		}
		// Assign a unique identifier to each event
		// as well as a reference to the parent group
		for (const event of this.eventGroups) {
			for (const line of event.lines) {
				line.uid = nanoid();
				line.parentUid = event.uid;
				line.matched = true;
			}
		}

		// Get all events from the groups
		this.events = this.eventGroups.flatMap(group => group.lines);

		// Delete lines as we don't need them anymore
		for (const group of this.eventGroups) {
			delete group.lines;
		}

		// console.log('this.events', this.events);
		// console.log('this.eventGroups', this.eventGroups);

		// this.drawChart();

		this.filterEvents();
	}

	/**
	 * Retrieve reference data from reference key
	 *
	 * @param {string} reference The reference key
	 * @returns {any} The data associated from the reference key
	 */
	getRef(reference) {
		return this.refs[reference];
	}

	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (this.data && this.kid) {
			this.data = changes.data.currentValue;
			this.kid = changes.kid.currentValue;

			// this.init();
		}
	}

	$onInit() {
		if (this.data && this.kid) {
			this.init();
		}
	}
}
